import React, { useEffect, useState } from 'react'
import LastCallSaleSlider from '../../Components/LastCallSaleComponents/LastCallSaleSlider/LastCallSaleSlider';
import LastCallSaleCategory from '../../Components/LastCallSaleComponents/LastCallSaleCategory/LastCallSaleCategory';
import LastCallSaleFinancing from '../../Components/LastCallSaleComponents/LastCallSaleFinancingSlider/LastCallSaleFinancing';
import LastCallSaleBanner from '../../Components/LastCallSaleComponents/LastCallSaleBanner/LastCallSaleBanner';
import { useLastCallSale } from '../../Context/active-sale-context/LastCallSaleContext';
import SectionLoader from '../../Components/UI-Controls/MainLoader/SectionLoader';
import BottomToust from '../../Components/BottomToust/BottomToust';

const LastCallSale = () => {
    const { getDataOfActiveSale, updateActiveSale, loading, message, } = useLastCallSale()
    const [openToust, setOpenToust] = useState(false)
    useEffect(() => { getDataOfActiveSale() }, [])
    
    const handleOpenToust = () => {
        setOpenToust(true);
    }

    const handleCloseToust = () => {
        setOpenToust(false);
    }

    return (
        <div className="HomePage" style={{ gap: '20px' }}>
            {loading && <SectionLoader />}
            <>
                <LastCallSaleSlider />
                <LastCallSaleCategory />
                <LastCallSaleFinancing />
                <LastCallSaleBanner />
                <div style={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'end'
                }}>
                    <button
                        style={{
                            width: 'max-content',
                            heightL: "max-content",
                            padding: '10px 25px',
                            backgroundColor: '#4487c5',
                            color: '#fff',
                            border: 'none',
                            outline: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer'
                        }}
                        onClick={() => {updateActiveSale() ; handleOpenToust()} }
                    >
                        Save
                    </button>
                </div>
            </>

            <BottomToust 
                message={message}
                showMessage={openToust}
                handleCloseMessageModal={handleCloseToust}
            />
        </div >
    );
}

export default LastCallSale